import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import { CreateSchemaObjectModal } from "../../features/Schemas/Components/CreateSchemaObjectModal";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { useEffect } from "react";
import { clearSchemasState } from "../../features/Schemas/redux/slice";

export const SchemasPage = () => {
  const dispatch = useAppDispatch();
  const { handleOpenModal } = useAppModals();
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("schemas");
  const { handleSelectObject } = useStorageObject(
    "schemas",
    "schemas",
    currentService,
  );

  useEffect(() => {
    return () => {
      dispatch(clearSchemasState());
    };
  }, []);

  useServiceNavigate("schemas", "schemas");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onSelect={handleSelectObject}
        onAdd={() => handleOpenModal("create_schema_object_modal", null)}
        selectedId={selectedObject?.id ?? ""}
        service={"schemas"}
        isLoading={isLoading ?? false}
        customCreateObject={(info) =>
          handleOpenModal("create_schema_object_modal", info)
        }
      />
      {selectedObject && <SafeOutlet />}
      <CreateSchemaObjectModal />
    </div>
  );
};
